<template>
  <div class="h-1/2 py-20 max-w-4xl mx-auto">
    <p
      class="inline mx-auto w-max text-4xl lg:text-8xl lg:text-center text-left font-bold pt-20 text-black"
    >
      Get early <span class="mini-sunset">access</span>
    </p>
    <p
      class="mx-auto text-center text-gray-600 text-base p-6 sm:w-1/2 sm:pt-8 sm:pb-20"
    >
      Evala is still in private beta and under development, but we would appretiate your early feedback. Enter your email and get a chance to become an early user.
    </p>
    <!-- <Input @input="captureMail" @send="createAdventurer()" class="mx-auto w-auto" /> -->
    <div :style="{display: applied ? 'none' : 'flex'}" class="flex flex-col mx-auto justify-center items-center mb-6 w-3/4 mt-12">
      <label
        for="email"
        class="block mb-2 text-base self-start font-medium text-gray-900 dark:text-gray-300"
        >Your email</label
      >
      <input
        type="text"
        v-model="email"
        @input="validateEmail()"
        class="bg-white border-gray-600 border-2 text-gray-900 text-xl rounded-lg focus-within:ring-orange-500 focus:ring-orange-500 focus:border-orange-500 block w-full px-4 py-3"
        placeholder="user@evala.io"
        required
      />
        <button @click="createAdventurer()" type="submit" :disabled='!emailValid' :style="{'background-color': !emailValid ? '#d3d3d3' : '#f97316'}" class="text-white hover:bg-orange-600 disabled:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-orange-500 font-medium rounded-3xl text-sm w-full sm:w-auto m-6 px-8 py-4 text-center">Apply</button>
    </div>
     <h1 :style="{visibility: applied ? 'visible' : 'hidden'}"
      class="mx-auto w-max text-2xl lg:text-4xl lg:text-center text-left font-bold pt-8 text-black"
    >
      You're in! Evala, adventurer!
    </h1>
  </div>
</template>

<script>
import { addDoc, collection } from "firebase/firestore";

import users from "../firebase.js";

export default {
  name: "Newsletter",
  components: {
  },
  data() {
    return {
      email: "",
      applied: false,
      emailValid: false
    };
  },
  methods: {
    validateEmail() {
      // prettier-ignore
      if (this.email.match("[^@\s]+@[^@\s]+\.[^@\s]+")){
        this.emailValid = true
      } else {
        this.emailValid = false
      }
    },
    createAdventurer() {
      const adventurer = { email: this.email, timestamp: Date() };

      addDoc(users, adventurer)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error(`Failed to fetch: ${error}`);
        });

        this.applied = true
    },
  },
};
</script>

<style lang="scss"></style>
